<template>
  <div class="container" v-show="loadOk" @click="saveEvent()">
    <div class="lineContainer">
      <hr class="horizontal-line"/>
      <div>Or</div>
      <hr class="horizontal-line"/>
    </div>
    <div class="signButton" id="signButton" style="opacity: 0;"/>
    <div class="loginElements">
      <div class="elements">
        <img class="img" :src="logo" alt=""/>
        <div class="text">continue with google</div>
      </div>
    </div>
  </div>
</template>
<script>
import logo from '@/assets/images/login/google.svg'
import {jwtDecode} from 'jwt-decode'
import {LogUtils} from '@/utils'
// 声明 google 为全局变量
/* global google */
export default {
  name: 'GoogleLogin',
  props: ['LoginMethod'],
  data () {
    return {
      logo,
      loadOk: false,
      isVIRLogin: localStorage.getItem('isVIRLogin')
    }
  },
  mounted () {
    this.loadGoogleAPI()
  },
  methods: {
    saveEvent () {
      const firstGoogleClick = localStorage.getItem('firstGoogleClick')
      if (!firstGoogleClick && localStorage.getItem('visitorCode')) {
        const param1 = window.Android ? 1 : 0
        const param2 = {
          VisitorCode: localStorage.getItem('visitorCode')
        }
        LogUtils.saveUserEventParams('firstGoogleClick', '', param1, JSON.stringify(param2))
        localStorage.setItem('firstGoogleClick', new Date().getTime())
      }
    },
    handleCredentialResponse (response) {
      // 处理用户响应
      const token = response.credential
      const decoded = jwtDecode(token)
      if (decoded && decoded.sub) {
        this.LoginMethod(decoded.sub, decoded.email)
      }
    },
    loadGoogleAPI () {
      const script = document.createElement('script')
      script.src = 'https://accounts.google.com/gsi/client'
      script.async = true
      script.defer = true
      document.body.appendChild(script)
      // client_id: '439807484378-iln528887hrvj2otaj19ousnqdldab9f.apps.googleusercontent.com',
      script.onload = () => {
        google.accounts.id.initialize({
          client_id: '117386137464-rv6tp94sg3ikhg1rjpkuim6eh7ild1kp.apps.googleusercontent.com',
          callback: this.handleCredentialResponse
        })
        google.accounts.id.renderButton(
          document.querySelector('.signButton'),
          {theme: 'outline', size: 'large', type: 'standard'}
        )
        this.onGoogleAPIInitialized()
      }
    },
    onGoogleAPIInitialized () {
      let doc = document.getElementById('signButton')
      if (doc) {
        this.setWidthRecursively(doc)
      }
      this.loadOk = true
    },
    setWidthRecursively (element) {
      element.style.width = '85.555vw'
      element.style.height = '11.111vw'
      for (let i = 0; i < element.children.length; i++) {
        this.setWidthRecursively(element.children[i])
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  position: relative;
  left: 50%;
  transform: translate(-50%);
  width: 85.555vw;
  height: max-content;

  .lineContainer {
    margin: 4.227vw auto 4.8vw auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 85.555vw;
    height: 4.444vw;
    text-align: center;
    font-size: 3.611vw;
    font-weight: 500;
    color: #6c6c6c;

    .horizontal-line {
      width: 35vw;
      border: none;
      border-top: 0.3vw solid #313131;
      margin: 0;
    }
  }

  .loginElements {
    width: 85.555vw;
    height: 11.388vw;
    border-radius: 2.222vw;
    background: #222326;
    margin: 0 auto;

    .elements {
      width: 49.166vw;
      height: 11.388vw;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .img {
        width: 6.9vw;
        height: 6.9vw;
      }

      .text {
        font-size: 3.888vw;
        font-weight: 500;
        color: #8D8C8C;
        text-transform: capitalize;
      }
    }
  }

  .signButton {
    position: absolute;
    left: 50%;
    width: 85.555vw;
    transform: translate(-50%);
    bottom: 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GoogleAuth/index.vue